// owner: W2 — zod schemas + inferred types shared by api and web
import { z } from 'zod';
import { EpochMsSchema, PaginationQuerySchema, UlidSchema, paginated } from './common';

export const AlertRemoteSchema = z.enum(['onsite', 'hybrid', 'remote']);

export const JobAlertCreateSchema = z.object({
  name: z.string().trim().max(100).default(''),
  keywords: z.string().trim().min(1).max(200),
  location: z.string().trim().max(200).default(''),
  remote: AlertRemoteSchema.nullish(),
});

export const JobAlertSchema = z.object({
  id: UlidSchema,
  name: z.string(),
  keywords: z.string(),
  location: z.string(),
  remote: AlertRemoteSchema.nullable(),
  /** A paused alert is skipped entirely by the daily cron: no matches, no notification, no email. */
  paused: z.boolean(),
  createdAt: EpochMsSchema,
  lastNotifiedAt: EpochMsSchema,
});
export type JobAlert = z.infer<typeof JobAlertSchema>;

export const JobAlertListSchema = paginated(JobAlertSchema);
export const JobAlertListQuerySchema = PaginationQuerySchema;
export const JobAlertIdParamsSchema = z.object({ id: UlidSchema });
export const JobAlertPauseSchema = z.object({ paused: z.boolean() });
export const DeletedAlertSchema = z.object({ deleted: z.literal(true) });
